import { EAbilityActions, EAbilitySubjects } from '@client/hooks/useAbilities';
import { schedulerDatesToTs } from '@client/services/scheduler.service';
import {
  CScheduler,
  type ESchedulerPrefix,
  type IScheduler,
  type TSchedulers,
} from '@common/types';

import type { MongoAbility } from '@casl/ability';
import type React from 'react';

export const isDisabledScheduler = (
  type: EAbilitySubjects,
  disabled: boolean,
  isEdit: boolean,
  ability: MongoAbility,
) => {
  const schedulerSubject = `${type}.${EAbilitySubjects.SCHEDULER}`;

  return (
    disabled ||
    ability.cannot(EAbilityActions.CREATE, schedulerSubject) ||
    (isEdit && ability.cannot(EAbilityActions.UPDATE, schedulerSubject))
  );
};

export const onCreateScheduler = (
  type: ESchedulerPrefix,
  scheduler: IScheduler,
  setAssignedSchedulers: React.Dispatch<React.SetStateAction<TSchedulers>>,
  setDirty: (dirty: boolean) => void,
) => {
  setAssignedSchedulers((prev) => {
    const list = prev[CScheduler][type] || [];
    return {
      [CScheduler]: {
        ...prev[CScheduler],
        [type]: [...list, schedulerDatesToTs(scheduler)],
      },
    };
  });

  setDirty(true);
};

export const onUpdateScheduler = (
  type: ESchedulerPrefix,
  scheduler: IScheduler,
  setAssignedSchedulers: React.Dispatch<React.SetStateAction<TSchedulers>>,
  setDirty: (dirty: boolean) => void,
) => {
  setAssignedSchedulers((prev) => {
    const list = prev[CScheduler][type] || [];
    const idx = list.findIndex((s) =>
      scheduler.id ? s.id === scheduler.id : s === scheduler,
    );
    const newList =
      idx >= 0
        ? [
            ...list.slice(0, idx),
            schedulerDatesToTs(scheduler),
            ...list.slice(idx + 1),
          ]
        : list;
    return {
      [CScheduler]: {
        ...prev[CScheduler],
        [type]: newList,
      },
    };
  });

  setDirty(true);
};

export const onDeleteScheduler = async (
  type: ESchedulerPrefix,
  schedulerId: string,
  assignedSchedulers: TSchedulers,
  onDelete: (entity: IScheduler) => Promise<void>,
  setDirty: (dirty: boolean) => void,
) => {
  const list = assignedSchedulers[CScheduler][type] || [];
  const entity = list.find((s) => s.id === schedulerId);

  if (entity) {
    await onDelete(entity);
    setDirty(true);
  }
};
